import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import ReadWidgetsClient from 'use-case/widgets/read/readWidgetsClient';
import ReadWidgetsCriteria from 'use-case/widgets/read/readWidgetsCriteria';
import { asWidget, WidgetJsonType } from 'adapter/out/client/widgets/mappers/WidgetMapper';

export default (httpClient: httpClientFunction, baseUrl: string): ReadWidgetsClient => (criteria: ReadWidgetsCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/widgets`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asWidgets)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asWidgets = (widgetsJson: WidgetsJsonType) => widgetsJson.map(asWidget);

type WidgetsJsonType = Array<WidgetJsonType>;
